import React from 'react';
import PropTypes from 'prop-types';

import InputText from './input-text';
import { usePostUpdateTwitterUrl } from '../../../../../services/profiles/contributor-settings-service';

export default function Twitter({ url, onUpdate }) {
  const [{ loading, error }, post] = usePostUpdateTwitterUrl();

  const onChange = value => {
    post(value).then(() => onUpdate(value));
  };

  return (
    <InputText
      initialValue={url}
      label="Twitter"
      placeholder="Example https://x.com/myname"
      onChange={onChange}
      isLoading={loading}
      error={error}
    />
  );
}

Twitter.propTypes = {
  url: PropTypes.string,
  onUpdate: PropTypes.func,
};

Twitter.defaultProps = {
  url: null,
  onUpdate: () => null,
};
